import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import About from '../components/pages/About';
import ContactUs from '../components/pages/ContactUs';
import Footer from '../components/footer/Footer';
import Header from '../components/header/Header';
import Nav from '../components/nav/Nav';
import NotFound from '../components/pages/NotFound';
import Teaser from '../components/pages/Teaser';

import './App.scss';

class App extends React.Component {
  getChildContext() {
    let baseUrl = 'https://aloha50.com';
    if (this.props.host) {
      baseUrl = `https://${this.props.host}`;
    } else if (typeof window != 'undefined' && window.location) {
      baseUrl = `${window.location.protocol}//${window.location.host}`;
    }
    return {
      global: {
        site: {
          baseUrl
        }
      }
    };
  }

  render() {
    return (
      <div>
        <Header />
        <Nav />
        <Switch>
          <Route exact path="/" component={Teaser} />
          <Route exact path="/about/" component={About} />
          <Route exact path="/contact-us/" component={ContactUs} />
          <Route exact path="*" component={NotFound} />
        </Switch>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.node,
  host: PropTypes.string
};


App.childContextTypes = {
  global: PropTypes.shape({
    site: PropTypes.shape({
      baseUrl: PropTypes.string.isRequired
    })
  }).isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/views/App.jsx